var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCurveFooterDesktop = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 1420 42"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#ECF6F1",
  d: "M0 41.575h1420v-25.5s-460-31.09-710-5.75-710 8.25-710 8.25z"
})));
export default SvgCurveFooterDesktop;